"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._deleteTrack = exports._updateTrack = exports._createTrack = exports._fetchEventTracks = void 0;
const api_1 = require("../../utils/api");
const base_1 = require("../../utils/base");
const _fetchEventTracks = (basePath, token, eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const tracks = yield (0, api_1.getRequest)(`${base.EVENTS}/${eventId}/tracks`, token);
    return (tracks === null || tracks === void 0 ? void 0 : tracks.data) || tracks;
});
exports._fetchEventTracks = _fetchEventTracks;
const _createTrack = (basePath, token, data) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const { data: response } = yield (0, api_1.postFilesAndDataRequest)(base.TRACKS, data, [], token);
    return response;
});
exports._createTrack = _createTrack;
const _updateTrack = (basePath, token, trackId, data) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const { data: response } = yield (0, api_1.postFilesAndDataRequest)(`${base.TRACKS}/${trackId}`, data, [], token, "put");
    return response;
});
exports._updateTrack = _updateTrack;
const _deleteTrack = (basePath, token, trackId) => __awaiter(void 0, void 0, void 0, function* () {
    const base = (0, base_1.getBasePath)(basePath);
    const response = yield (0, api_1.deleteRequestWE)(`${base.TRACKS}/${trackId}`, token);
    return response;
});
exports._deleteTrack = _deleteTrack;
